import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import NoPage from "./pages/NoPage";
import EventDetails from "./pages/event-details";
import Contact from "./pages/contact";
import Cartelera from "./pages/cartelera";



export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Cartelera />} />
        <Route path="*" element={<NoPage />} />
         <Route path="event-details/:eventoId" element={<EventDetails />} />
         <Route path="contact" element={<Contact />} />
         <Route path="home" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
